import React from 'react';
interface ContentSectionProps {
  id?: string;
  eyebrow?: string;
  title?: string;
  intro?: React.ReactNode;
  tone?: 'white' | 'warm';
  children?: React.ReactNode;
}
export function ContentSection({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  children
}: ContentSectionProps) {
  const headingId = id ? `${id}-heading` : undefined;
  return <section id={id} aria-labelledby={title ? headingId : undefined} className={`w-full border-b border-rule ${tone === 'warm' ? 'bg-warm' : 'bg-white'}`} data-id="element-540" data-mp="bw9y4sxel5ir">
      <div className="mx-auto max-w-shell px-5 py-12 lg:px-10 lg:py-16" data-id="element-541" data-mp="22azi3wjg3vk">
        {eyebrow ? <p className="flex items-center gap-3 font-mono text-[10px] tracking-label text-copper" data-id="element-542" data-mp="3t8m76iw202vv">
            <span aria-hidden="true" className="h-px w-6 bg-copper" data-id="element-543" data-mp="3o9j0yv4c7qmb" />
            {eyebrow.toUpperCase()}
          </p> : null}
        {title ? <h2 id={headingId} className={`max-w-[30ch] font-display text-[clamp(1.4rem,2.3vw,1.95rem)] font-medium leading-[1.15] text-navy ${eyebrow ? 'mt-4' : ''}`} data-id="element-544" data-mp="3fanxhqsogump">
            {title}
          </h2> : null}
        {intro ? <div className="rp-measure mt-4 space-y-4 text-[15.5px] leading-[1.7] text-graphite/85" data-id="element-545" data-mp="cib16ku0d0cf">
            {intro}
          </div> : null}
        {children ? <div className={title || intro ? 'mt-8' : ''} data-id="element-546" data-mp="148pas4uznqia">{children}</div> : null}
      </div>
    </section>;
}